import React, {useEffect, useState, useCallback} from 'react';
import {useSelector} from "react-redux";
import MindsetsJsSDK from "mindsets-js-sdk";
import {debounce} from 'lodash';

import SkillGraph from './SkillGraph';
import CategoryGraph from './CategoryGraph';
import StudentTable from './StudentTable';

import "./pam_template_type_a.scss";

export default function ({dashboard_id}) {

    const [dataSkill, setDataSkill] = useState(undefined);
    const [dataCategory, setDataCategory] = useState(undefined);
    const [dataStudentTable, setDataStudentTable] = useState({});
    const dashboard_filters = useSelector(state => state.dashboard_filters);
    // console.log('dashboard_filters', dashboard_filters);

    const debounceLoadData = useCallback(
        debounce((dashboard_id, dashboard_filters, page) => {
            if (page === undefined) {
                MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/skills`, {...dashboard_filters}).then((response) => {
                    setDataSkill(response);
                });
                MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/categories`, {...dashboard_filters}).then((response) => {
                    setDataCategory(response);
                });
            }
            const current = page ? page : 1;
            MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/data`, {current, ...dashboard_filters}).then((response) => {
                setDataStudentTable(response);
            });
        }, 1000),
        []
    );

    useEffect(() => {
        debounceLoadData(dashboard_id, dashboard_filters, undefined);
    }, [dashboard_id, dashboard_filters]);

    const selectPage = (page) => {
        if (dataStudentTable.current == page) {
            return false;
        }
        debounceLoadData(dashboard_id, dashboard_filters, page);
    }

    return (
        <div id="pam-template-type-a">
            <div className="flex-row flex-gap-10 flex-wrap">
                <SkillGraph
                    dataSkill={dataSkill}
                />

                <CategoryGraph
                    dataCategory={dataCategory}
                />
            </div>

            <div>
                <StudentTable
                    dataStudentTable={dataStudentTable}
                    selectPage={selectPage}
                />
            </div>
        </div>
    );
}
